@if (isZoomable$() && hasZoomableImages$()) {
	<button type="button" class="product-image zoomable" (click)="handleZoom()">
		<img
			[src]="currentImageUrl$()"
			[alt]="localizedAltText$()"
			loading="auto"
			fill
			(load)="handleImageLoad()"
			(error)="handleImageError()"
		/>
	</button>
} @else {
	<figure class="product-image">
		<img
			[src]="currentImageUrl$()"
			[alt]="localizedAltText$()"
			loading="auto"
			fill
			(load)="handleImageLoad()"
			(error)="handleImageError()"
		/>
	</figure>
}
